import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { map, Observable } from 'rxjs';

import { Admission, AdmissionsResponse, Ingredient, IngredientsResponse, UpsertResponse } from '../models/crop-aid-admission.models';

@Injectable()
export class CropAidAdmissionService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject<AgrEnvironment>(EnvironmentInjector);
  private readonly baseUrl = `${this.environment.APIM_BASE_URL}/arable-service`;

  getAdmissions(): Observable<Admission[]> {
    return this.http.get<AdmissionsResponse>(`${this.baseUrl}/admission`).pipe(map(({ admissions }) => admissions));
  }

  upsertAdmission(admission: Admission): Observable<UpsertResponse> {
    return this.http.post<UpsertResponse>(`${this.baseUrl}/admission`, admission);
  }

  getIngredients(): Observable<Ingredient[]> {
    return this.http.get<IngredientsResponse>(`${this.baseUrl}/ingredient`).pipe(map(({ ingredients }) => ingredients));
  }

  upsertIngredient(ingredient: Ingredient): Observable<UpsertResponse> {
    return this.http.post<UpsertResponse>(`${this.baseUrl}/ingredient`, ingredient);
  }
}
